import { FormattedMessage, useIntl } from "react-intl";
import { ActionBar, ActionBarButtons, CreateActionButton } from "../ActionBar";
import Hint from "../Hint";
import { Column, Row } from "../Grid";
import { Loader } from "../index";
import { useApi } from "../../hooks";
import DataExportItem from "./DataExportItem";
import {
  extractDataExport,
  extractDataExports,
} from "../../extractors/dataExportsExtractor";
import { DataExportsDescription } from "./DataExportsDescription";
import { useNotifier } from "../../context";

type Props = {
  exportType: string;
};

export default function DataExports({ exportType }: Props) {
  const notifier = useNotifier();
  const intl = useIntl();
  const api = useApi();

  const handleSuccess = () => {
    notifier.showSuccess(
      intl.formatMessage({ id: "data_export.success_notification" }),
    );
  };

  const filter = { order_by: "-created_at" };
  if (!exportType.includes("complete")) {
    (filter as $TSFixMe).type = exportType;
  }
  const { data: dataExports, isLoading } = api.get.useQuery(
    "/users/current/data_exports",
    filter,
  );
  const { mutate } = api.post.useMutation("/users/current/data_exports");

  const onCreate = () => {
    mutate({ type: "complete" }, { onSuccess: handleSuccess });
  };

  return (
    <Row>
      <Column>
        <ActionBar>
          <h2 id="export-data-header">
            <FormattedMessage id="export_data.header" />
          </h2>
          <ActionBarButtons>
            {exportType === "complete" ? (
              <CreateActionButton
                // @ts-expect-error TS(2322) FIXME: Type '{ icon: string; id: string; onClick: () => v... Remove this comment to see the full error message
                icon="icon-eh-export"
                id="export-file-button"
                onClick={onCreate}
                // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
                disabled={dataExports?.data_exports.some(
                  (exp: $TSFixMe) => exp.type === "complete",
                )}
              />
            ) : null}
          </ActionBarButtons>
        </ActionBar>
        <Row>
          <Column>
            <table className="table" cellSpacing="0">
              <thead>
                <tr>
                  <th>
                    <FormattedMessage id="label.status" />
                  </th>
                  <th>
                    <FormattedMessage id="label.type" />
                  </th>
                  <th className="hidden-xs">
                    <FormattedMessage id="label.object_export" />
                  </th>
                  <th className="hidden-xs">
                    <FormattedMessage id="label.started" />
                  </th>
                  <th className="hidden-xs">
                    <FormattedMessage id="label.finished" />
                  </th>
                  <th>
                    <FormattedMessage id="label.available_until" />
                  </th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {/* @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'. */}
                {dataExports?.data_exports.map((dataExport: $TSFixMe) => (
                  <DataExportItem
                    key={`data-export-${dataExport.id}`}
                    // @ts-expect-error TS(2322) FIXME: Type '{ key: string; dataExport: { id: any; status... Remove this comment to see the full error message
                    dataExport={extractDataExport(dataExport)}
                    exportType={dataExport.type}
                    data-testid={`data-export-${dataExport.id}`}
                  />
                ))}
              </tbody>
            </table>
            {/* @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'. */}
            {dataExports?.data_exports.length === 0 && (
              <Hint
                id="empty_hint"
                title={intl.formatMessage({ id: "hint.no_export_data" })}
                details={intl.formatMessage({ id: "hint.no_export_data.text" })}
              />
            )}
            {dataExports && (
              <DataExportsDescription
                exportType={exportType}
                dataExports={extractDataExports(dataExports)}
              />
            )}
          </Column>
        </Row>
        <Loader loading={isLoading} />
      </Column>
    </Row>
  );
}
